var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('org-home-stats-fees'),_c('org-home-stats-new-cases'),_c('org-home-stats-demands'),_c('org-home-stats-inventory')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }